export enum PlcType {
  UNDEFINED = 'Undefined',
  ECO_BASIC_CONTROL_LARGE = 'ecoBasicControlLarge',
  ECO_BASIC_CONTROL_MEDIUM = 'ecoBasicControlMedium',
  ECO_BASIC_CONTROL_SMALL = 'ecoBasicControlSmall',
  ECO_BASIC_CONTROL_LIGHT = 'ecoBasicControlLight',
  ECO_BASIC_CONTROL_LARGE_VIRTUAL = 'ecoBasicControlLargeVirtual'
}

export enum ArchitectureType {
  None = 'None',
  Classic = 'Classic',
  ObjectOriented = 'ObjectOriented'
}

export enum SourceLanguage {
  StructuredText = 'StructuredText',
  CSharp = 'CSharp',
}

export enum ControlTypeV2 {
  Action = 'Action',
  Actions = 'Actions',
  Toggle = 'Toggle',
  Toggles = 'Toggles',
  ConsumptionProcessToggle = 'ConsumptionProcessToggle',
  BooleanDisplay = 'BooleanDisplay',
  NumericDisplay = 'NumericDisplay',
  EnumDisplay = 'EnumDisplay',
  TimeDisplay = 'TimeDisplay',
  NumericInput = 'NumericInput',
  TextDisplay = 'TextDisplay',
  TextInput = 'TextInput',
  EnumInput = 'EnumInput',
  Links = 'Links',
  DeviceMessages = 'DeviceMessages',
  StateOfChargeConfiguration = 'StateOfChargeConfiguration',
  ArrayContainer = 'ArrayContainer',
}

export enum EnergyStatusItemType {
  ProducerPower = 'ProducerPower',
  ConsumerPower = 'ConsumerPower',
  BufferPower = 'BufferPower',
  BufferLevel = 'BufferLevel',
  GridPower = 'GridPower',
  HousePower = 'HousePower',
}

export enum AlarmOperator {
  Equal = '==',
  LessThan = '<',
  GreaterThan = '>',
}

export enum AlarmLevel {
  Critical = 'Critical',
  Information = 'Information',
}

export enum PlcOperationState {
  Disconnected = 'Disconnected',
  OnlinePartiallyReady = 'OnlinePartiallyReady',
  OnlineReady = 'OnlineReady',
  Offline = 'Offline',
  Updating = 'Updating',
  OnlineError = 'OnlineError',
}

export enum Permission {
  READ = 'Read',
  EDIT = 'Edit',
  DELETE = 'Delete',
  EXECUTE = 'Execute',
  AUTHORIZE = 'Authorize',
  SYSTEM_NOTIFICATION = 'SystemNotification',
  SYSTEM_NOTIFICATION_EMAIL = 'SystemNotificationEmail',
  CUSTOM_NOTIFICATION = 'CustomNotification',
  CUSTOM_NOTIFICATION_EMAIL = 'CustomNotificationEmail',
}

export enum Permissions {
  SystemOperationsAdministrator = '8525b563-9c08-4cbf-ad1d-0ae2dd9d6051',
  RealtimeSystemConfiguration = '927487b4-edaa-473e-bd45-6421f6bff725',
  EcoCloudConnectorTestReleaseDeployment = 'a04acc95-efc2-428f-887e-1438a3ae1529',
  ComponentFirmwareManagement = '570d9dad-9baa-4bae-834b-48c59a646536',
  FeatureManagement = 'cd993cf1-cde7-4254-97ed-c1f64d9fb696',
  PilotSiteAdministrator = '2c5cf3d5-3c48-4319-87ce-b3fbbd1ab2b2',
  LicenseManagement = '6ff5444c-82ba-4718-b6c4-c5cf6e715f17',
  PartnerManagement = '53b07918-ad80-4e78-865a-086054a7f054',
  ConfigurationFileDownload = "c128f408-37c6-44da-92ed-eac5bea33750",
}